export default __webpack_public_path__ + "static/media/black-rectangle-measure-icon.c9838d2e.svg";